<template>
  <div>
    <div class="contact_box">
      <div class="contact_item">
        <img src="@/assets/img/login_bg/email.png" alt="" />
        <div style="display: flex; align-items: center;">
          <p class="title">{{ $t("lang.邮箱") }}: </p>
          <p>zjzdst3@163.com</p>
        </div>
      </div>
      <div class="contact_item">
        <img src="@/assets/img/login_bg/address.png" alt="" />
        <div style="display: flex; align-items: center;">
          <p class="title">{{ $t("lang.智电官网") }}: </p>
          <a href="http://www.zdian-e.com" target="_blank"
            >http://www.zdian-e.com</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang='less'>
.contact_box {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;

  img {
    width: 25px;
    height: 25px;
    margin-right: 8px;
  }
  .contact_item {
    display: flex;
    align-items: center;
    padding: 0 29px;
    border-right: 1px solid #b3d5ff;
    .title{
      margin-right: 4px;
    }
    p {
      color: #fff;
      font-size: 14px;
    }
    a {
      color: #fff;
    }
  }
  .contact_item:last-child {
    border-right: none;
  }
}
</style>